import styled from 'astroturf/react';

const ReportReviewBlock = styled('div')`
  margin-top: 15px;
  border: 1px solid var(--ph-gray-50);
`;

const ReportReviewNoteInfoBox = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80px;
`;

const ReportReviewNoteBoxNoteInfoLeft = styled('div')`
  flex: 1;
`;

const ReportReviewBlockNoteTimeBox = styled('div')`
  display: flex;
  flex-direction: column;
`;

const ReportReviewBlockNoteTime = styled('div')`
  display: inline-flex;
`;

const ReportReviewBlockNoteTimeText = styled('div')`
  width: 123px;
  height: 15px;
  font-family: SFCompactText; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  color: var(--dune);
  display: inline-box;
  margin: 5px 0;
`;

const ReportReviewNoteBoxNoteInfoLeftIn = styled('div')`
  font-size: 16px;
  position: relative;
  left: 50px;
  white-space: nowrap;
  margin: 5px 0;
`;

const ReportReviewCommentText = styled('div')`
  width: 431px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: var(--dune);
  padding: 0 0 0 60px;
  margin-bottom: 30px;
  overflow-wrap: break-word;

  &.isLastComment {
    margin-bottom: 0;
  }
`;

const ReportReviewBlockTimeWrapperDiv = styled('div')`
  position: relative;
`;

export default {
  ReportReviewBlock,
  ReportReviewNoteInfoBox,
  ReportReviewNoteBoxNoteInfoLeft,
  ReportReviewBlockNoteTimeBox,
  ReportReviewBlockNoteTime,
  ReportReviewBlockNoteTimeText,
  ReportReviewNoteBoxNoteInfoLeftIn,
  ReportReviewCommentText,
  ReportReviewBlockTimeWrapperDiv,
};
